import React, { Fragment } from 'react';
import { View } from 'react-native';
import { Divider } from '@ui-kitten/components';

import { RectangleLoader } from '../../../Components/Loader';
import ListItemLoader from '../../../Components/ListItemLoader';
import themeStyle from '../../../Theme/styles';
import { ids, styles } from '../../../Theme/styles/platform';
import { numberToArray } from '../../../Helper';

const OverviewLoader = () => {
  const loader = numberToArray(4);
  return (
    <View>
      <View dataSet={{ media: ids.webOnly }} style={styles.webOnly}>
        <RectangleLoader width={170} height={39} />
      </View>
      {loader.map((_, i) => (
        <Fragment key={i}>
          <ListItemLoader
            contentContainerStyle={themeStyle.pageVerticalSpacingMedium}
            withLeftIcon
          />
          {i !== loader.length - 1 && <Divider style={themeStyle.divider} />}
        </Fragment>
      ))}
    </View>
  );
};

export default OverviewLoader;
